import React from "react";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";

// Use portal to render the modal outside the main app hierarchy
const TrialModal = () => {
  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2001,
        pointerEvents: "all", // Ensure clicks work
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "40px",
          paddingTop: "80px", // Increased top padding to make room for the avatar
          borderRadius: "20px",
          maxWidth: "500px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 5px 30px rgba(0, 0, 0, 0.5)",
          animation: "slideUp 0.5s ease-out",
          opacity: 1,
          position: "relative", // For absolute positioning of the Links avatar
        }}
      >
        {/* Happy Links Avatar at the top */}
        <div
          style={{
            position: "absolute",
            top: "-60px", // Position above the modal
            left: "50%",
            transform: "translateX(-50%)",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            backgroundColor: "#f3e1b2",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <img
            src="/links_avatar/excited_links.png" // Use the excited version of Links
            alt="Happy Links"
            style={{
              width: "140%", // Slightly larger than container
              height: "140%",
              objectFit: "contain",
              objectPosition: "center 45%", // Position to show more of Links' face
              transform: "translateY(5px)", // Adjust position slightly downward
            }}
            draggable="false"
          />
        </div>

        <h2
          style={{
            margin: "0 0 20px",
            color: "#333",
            fontFamily: "'Inter', sans-serif",
            fontSize: "28px",
          }}
        >
          Continue with Links!
        </h2>
        <p
          style={{
            margin: "0 0 30px",
            color: "#555",
            fontFamily: "'Inter', sans-serif",
            fontSize: "18px",
            lineHeight: "1.6",
          }}
        >
          Log in or create an account to continue learning and track your
          progress!
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/login"
            style={{
              backgroundColor: "#9CDAED",
              color: "#000",
              padding: "14px 30px",
              borderRadius: "12px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "18px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease, transform 0.2s ease",
              fontFamily: "'Inter', sans-serif",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            Log In
          </Link>
          <Link
            to="/register"
            style={{
              backgroundColor: "#f3e1b2",
              color: "#000",
              padding: "14px 30px",
              borderRadius: "12px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "18px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease, transform 0.2s ease",
              fontFamily: "'Inter', sans-serif",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            Sign Up
          </Link>
        </div>
      </div>
      <style>
        {`
          @keyframes slideUp {
            from { transform: translateY(50px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
    </div>,
    document.body
  );
};

export default TrialModal;
